/* begin general import */

import TrashCan16 from "@carbon/icons-react/es/trash-can/16";
import { Col, Popconfirm, Row } from "antd";
import Table, { ColumnProps } from "antd/lib/table";
import { TFunction } from "i18next";
import { AppUser } from "models/AppUser";
import { Role, RoleFilter } from "models/Role";
import React, { useEffect, useState } from "react";
import { Model } from "react3l-common";
import { FormItem, Modal, Select } from "react3l-ui-library";
import { appUserRepository } from "repositories/app-user-repository";
import { utilService } from "services/common-services/util-service";
import nameof from "ts-nameof.macro";
import { Close20 } from "@carbon/icons-react";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";

interface AppUserPermissionModalProps<T extends Model> {
  model?: T;
  isOpenRoleModel?: boolean;
  isLoadingPreview?: boolean;
  handleCloseRoleModel?: () => void;
  onSave?: (selectedList: Role[]) => void;
  translate?: TFunction;
  checkArrModalEmpty: boolean;
  setCheckArrModalEmpty: any;
}

export function AppUserPermissionModal(
  props: AppUserPermissionModalProps<AppUser>
) {
  const {
    model,
    isOpenRoleModel,
    handleCloseRoleModel,
    onSave,
    translate,
    setCheckArrModalEmpty,
  } = props;
  const [role, setRole] = React.useState<Role>(undefined);
  const [selectedList, setSelectedList] = React.useState<Role[]>([]);
  const [selectedListModel, setSelectedListModel] = React.useState<Role[]>([]);
  const [roleFilter, setRoleFilter] = React.useState<RoleFilter>(
    new RoleFilter()
  );
  const [arrId, setArrId] = useState([]);
  const ref = React.useRef<boolean>(true);
  let modelHere = _.cloneDeep(model);

  React.useEffect(() => {
    if (isOpenRoleModel) {
      modelHere.appUserRoles = modelHere?.appUserRoles?.filter(
        (x: any) => x.roleId
      );
      if (ref.current) {
        if (modelHere?.appUserRoles && modelHere?.appUserRoles.length > 0) {
          const selected = modelHere?.appUserRoles.map(
            (item: any) => item?.role
          );
          for (let i = 0; i < selected?.length; i++) {
            selected[i].key = uuidv4();
          }
          // .filter((item: Role) => (item?.roleType?.code !== "Speacial" || !item?.roleType));
          setSelectedList(selected);
          const arrSelectedNotSpecial = selected.filter((item: Role) => item?.roleType?.code !== "Speacial");
          const arrNotDup = _.uniqBy(arrSelectedNotSpecial, (obj: any) => obj?.code);
          setSelectedListModel(arrNotDup);
          const ids = selected.map((role: any) => role.id);
          roleFilter.id.notIn = ids;
          setRoleFilter({ ...roleFilter });
          ref.current = false;
          setCheckArrModalEmpty(false);
        } else {
          setSelectedList([]);
          setSelectedListModel([]);
          ref.current = false;
          setCheckArrModalEmpty(true);
        }
      }
    } else {
      ref.current = true;
    }
  }, [
    isOpenRoleModel,
    modelHere?.appUserRoles,
    roleFilter,
    modelHere,
    selectedList,
    setCheckArrModalEmpty,
  ]);

  useEffect(() => {
    let arrIdHere = [];
    for (let i = 0; i < selectedList.length; i++) {
      arrIdHere.push(selectedList[i].id);
    }
    setArrId(arrIdHere);
  }, [selectedList]);

  // const handleAddRole = React.useCallback(() => {
  //     if (role?.id !== undefined) {
  //         const ids = selectedList.map((role) => role.id);
  //         if (!ids.includes(role.id)) {
  //             selectedList.push(role);
  //             setSelectedList([...selectedList]);
  //         }
  //         roleFilter.id.notIn = ids;
  //         setRoleFilter({ ...roleFilter });
  //         setRole(undefined);
  //     }
  // }, [role, selectedList, roleFilter]);

  const hanldeChangeMappingRole = React.useCallback(
    (valueId, valueObject) => {
      // setRole(valueObject);
      if (valueObject?.id !== undefined) {
        const ids = selectedList.map((role) => role.id);
        if (!ids.includes(valueObject.id)) {
          selectedList.push(valueObject);
          setSelectedList([...selectedList]);
          setSelectedListModel([
            ...selectedList.filter(
              (item: Role) => item?.roleType?.code !== "Speacial"
            ),
          ]);
        }
        roleFilter.id.notIn = ids;
        setRoleFilter({ ...roleFilter });
        setRole(undefined);
      }
      // handleAddRole();
    },
    [roleFilter, selectedList]
  );

  const handleDeleteItem = React.useCallback(
    (item: Role, index: number) => {
      if (index > -1) {
        // selectedList.splice(index, 1);
        selectedListModel.splice(index, 1);
        selectedList.splice(selectedList.indexOf(item), 1);
      }
      setSelectedList([...selectedList]);
      setSelectedListModel([...selectedListModel]);
      setRole(undefined);
      if (selectedList?.length === 0) {
        setCheckArrModalEmpty(true);
      }
    },
    [selectedList, selectedListModel, setCheckArrModalEmpty]
  );

  const handleSave = React.useCallback(() => {
    if (typeof onSave === "function") {
      setRole(undefined);
      onSave(selectedList);
    }
  }, [onSave, selectedList]);

  const columns: ColumnProps<Role>[] = React.useMemo(() => {
    return [
      {
        title: (
          <div className="text-left gradient-text">
            {translate("appUsers.roles.code")}
          </div>
        ),
        key: nameof(selectedList[0].code),
        dataIndex: nameof(selectedList[0].code),
        width: 150,
        ellipsis: true,
      },
      {
        title: (
          <div className="text-left gradient-text">
            {translate("appUsers.roles.name")}
          </div>
        ),
        width: 150,
        key: nameof(selectedList[0].name),
        dataIndex: nameof(selectedList[0].name),
        ellipsis: true,
      },
      {
        title: (
          <div className="text-center gradient-text">
            {translate("general.actions.label")}
          </div>
        ),
        key: "action",
        dataIndex: "action",
        fixed: "right",
        width: 80,
        align: "center",
        render(...params: [string, Role, number]) {
          return (
            <div className="d-flex justify-content-center button-action-table">
              <Popconfirm
                placement="top"
                title={translate("general.deletes.content")}
                onConfirm={() => handleDeleteItem(params[1], params[2])}
                okText={translate("general.actions.delete")}
                cancelText={translate("general.actions.cancel")}
              >
                <button className="btn btn-sm ">
                  <TrashCan16 color="red" />
                </button>
              </Popconfirm>
            </div>
          );
        },
      },
    ];
  }, [handleDeleteItem, selectedList, translate]);
  const handleClose = React.useCallback(() => {
    setRoleFilter(new RoleFilter());
    handleCloseRoleModel();
  }, [handleCloseRoleModel]);

  return (
    <>
      <Modal
        size={1024}
        visible={isOpenRoleModel}
        visibleFooter={true}
        handleSave={handleSave}
        handleCancel={handleClose}
        titleButtonCancel={translate("general.actions.close")}
        titleButtonApply={translate("general.actions.save")}
        className="m-t--sm"
        title={translate("appUsers.addRoleAccount")}
        closable={false}
        wrapClassName={"dxg-modal-wrap"}
      >
        <div className="modal-content">
          <Row className="d-flex justify-content-between align-items-center m-t--xs">
            <Col lg={14}>
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.status)
                )}
                message={model.errors?.status}
              >
                <Select
                  type={0}
                  classFilter={RoleFilter}
                  searchProperty={"name"}
                  placeHolder={translate("appUsers.placeholder.role")}
                  getList={appUserRepository.singleListRole}
                  onChange={hanldeChangeMappingRole}
                  value={role}
                  valueFilter={{ ...new RoleFilter(), id: { notIn: arrId } }}
                />
              </FormItem>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Table
              key={selectedList[0]?.id}
              tableLayout="fixed"
              columns={columns}
              dataSource={selectedListModel}
              pagination={false}
              rowKey={"key"}
              className=" m-t--xs"
              scroll={{ y: 300 }}
            />
          </Row>
        </div>

        <span className={"close-modal"} onClick={handleClose}>
          <Close20 />
        </span>
      </Modal>
    </>
  );
}

export default AppUserPermissionModal;
